import { defineMessages } from 'react-intl';

export default defineMessages({
  subtitle: {
    id: 'sku-integrated-partner-banner--subtitle',
    defaultMessage:
      "Menu details can be edited in {integrationName}. If something doesn't look right, please contact us.",
  },
  contactUs: {
    id: 'sku-integrated-partner-banner--contact-us',
    defaultMessage: 'Contact us',
  },
});
